import { render, staticRenderFns } from "./CammandForm.vue?vue&type=template&id=630daec4&scoped=true"
import script from "./CammandForm.vue?vue&type=script&lang=js"
export * from "./CammandForm.vue?vue&type=script&lang=js"
import style0 from "./CammandForm.vue?vue&type=style&index=0&id=630daec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630daec4",
  null
  
)

export default component.exports